export default "__VITE_ASSET__BwGZUCKv__"